import { PostCard, type PostCardData } from '@/features/blog/components/post-card'
import { trackRelatedClick } from '@/lib/analytics/events'

export function RelatedArticles({
  posts,
  locale,
  title,
}: {
  posts: PostCardData[]
  locale: string
  title: string
}) {
  if (posts.length === 0) return null
  return (
    <section className="mt-10 border-t border-border pt-10">
      <h2 className="font-serif text-2xl font-bold text-primary">{title}</h2>
      <div className="mt-6 grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
        {posts.map((post) => (
          <PostCard
            key={post.slug}
            post={post}
            locale={locale}
            onNavigate={() => trackRelatedClick({ destination: `/blog/${post.slug}` })}
          />
        ))}
      </div>
    </section>
  )
}
